var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    fill: "#260C6A",
    rx: 18.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    stroke: "#fff",
    strokeWidth: 3,
    rx: 18.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F9",
    d: "M25.92 10.8h2.945l-6.432 7.625L30 28.8h-5.925l-4.64-6.293-5.31 6.293h-2.946l6.88-8.155-7.26-9.845h6.076l4.194 5.752zm-1.033 16.172h1.632l-10.53-14.44h-1.751z"
  })));
};
export default SvgX;